module.exports = __webpack_public_path__ + "static/media/trial-mac.a91c99f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trial-mac.jpg
// module id = 95
// module chunks = 3